import IconeAjuda from '@/global/components/IconeAjuda'
import { Grid } from '@mui/material'
import { FormField } from 'global/components/Form'

const DIAS = [
    {
        short: 'seg',
        long: 'Segunda-feira',
    },
    {
        short: 'ter',
        long: 'Terça-feira',
    },
    {
        short: 'qua',
        long: 'Quarta-feira',
    },
    {
        short: 'qui',
        long: 'Quinta-feira',
    },
    {
        short: 'sex',
        long: 'Sexta-feira',
    },
    {
        short: 'sab',
        long: 'Sábado',
    },
    {
        short: 'dom',
        long: 'Domingo',
    },
    { short: 'fer', long: 'Feriado' },
]

export default function FormHorista() {
    return [
        <Grid item xs={12} key="header">
            <span className="flex flex-col gap-1 select-none">
                <span className="text-sm font-semibold inline-flex items-center">
                    Máximo de horas diárias
                    <IconeAjuda className="ml-2">
                        O trabalhador horista tem os mesmos limites legais na
                        jornada que os demais trabalhadores em regime CLT: 8
                        horas diárias, porém, o empregador em comum acordo com o
                        empregado pode estabelecer condições de trabalho
                        diferentes.
                    </IconeAjuda>
                </span>
                <span className="text-xs">
                    Máximo de horas que o funcionário pode trabalhar por dia
                    antes de ser considerado hora extra.
                </span>
                <span className="text-xs">
                    Deixe em branco para indeterminado
                </span>
            </span>
        </Grid>,
        ...DIAS.map(dia => (
            <Grid item sm={3} xs={6} key={dia.short}>
                <FormField
                    name={`horasExtras.${dia.short}.maximoHorasDiarias`}
                    label={dia.long}
                    type="time"
                />
            </Grid>
        )),
    ]
}
